const Table = (props) => {
  const { title, headData, tableBody, columnWidths } = props || {};

  return (
    <div className="overflow-x-auto border border-purple-100 rounded-xl">
      {!!title && (
          <div className="bg-lightBlue/60 py-5 px-6 border-b  border-purple-100">
        <span className="font-semibold text-lg text-gray-900">
          {title}
        </span>
        </div>
      )}
      <table className="min-w-full table-fixed">
        {columnWidths && (
          <colgroup>
            {columnWidths.map((width, index) => (
              <col key={index} style={{ width }} />
            ))}
          </colgroup>
        )}
        <thead>
        <tr className={`${!title && "bg-lightBlue/60 "}`}>
            {headData.map((head) => (
              <th
                key={head}
                className="px-6 py-5 text-sm font-semibold text-gray-900 text-center"
              >
                {head}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="bg-white">{tableBody}</tbody>
      </table>
    </div>
  );
};

export default Table;
